function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 1,
  x2: 23.934,
  y2: 1,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 8,
  x2: 23.934,
  y2: 8,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1.98242,
  y1: 15,
  x2: 23.934,
  y2: 15,
  stroke: "#2E0A63",
  strokeWidth: 2,
  strokeLinecap: "round"
});
const SvgMenu = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 25,
  height: 16,
  viewBox: "0 0 25 16",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.94875fdc.svg";
export { ForwardRef as ReactComponent };